import moment from 'moment'
import { formatDate } from '@/utils'

export const toDollarFormat = dollarFloat => {
  let numberString = Number.parseFloat(dollarFloat).toFixed(2)
  let parts = numberString.split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return `$${parts.join('.')}`
}

export const toLocalDate = (date) => {
  return date ? formatDate(date, 'MM/DD/YYYY') : ''
}

export default {
  methods: {
    formatDate(date, format = 'MM/DD/YYYY') {
      return formatDate(date, format)
    },
    now() {
      return this.toIso8601Date(new Date())
    },
    toLocalDate(date) {
      return toLocalDate(date)
    },
    toIso8601Date(date) {
      try {
        return formatDate(date, 'YYYY-MM-DD')
      } catch (error) {
        return '' // whut we doin here?
      }
    },
    // TODO - unused func with undefined var
    stringToIso8601(date) {
      return this.toIso8601Date(moment(str, date).toDate())
    },
    toDollarFormat (dollarFloat = 0) {
      return toDollarFormat(dollarFloat)
    },
    validDate(date) {
      return moment(date).isValid()
    }
  }
}
